import src from "IMAGE";
export default { src, width: 74, height: 64, blurWidth: 0, blurHeight: 0};
